<template>
  <div>
    <DataLoader :is_on="main_loading" />

    <div class="case-top-line">
      <div class="case-top-line-left">
        <img
          v-if="isLaw"
          class="top-user-img"
          :src="getAvatar"
          @error="imgErr = true"
        />
        <div v-if="!isInstitucija" class="case-name">
          {{ represented_pers.ime }} {{ represented_pers.prezime }}
        </div>
        <div v-else class="case-name">
          {{ represented_pers.naziv }}
        </div>
        <div class="case-tab-buttons-wrapper">
          <div
            v-if="!isLaw"
            class="add-inhouse-btn white add-pen"
            @click="editOsoba()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  />
                </g>
              </g>
            </svg>
            <span>{{ $t("person_page.edit_btn") }}</span>
          </div>
          <div
            v-if="isPravna || isFizicka"
            :class="[
              'add-inhouse-btn white add-pen',
              represented_pers.crm ? 'active' : '',
            ]"
            @click="initCRM()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="32"
              viewBox="0 0 20 32"
            >
              <g>
                <g>
                  <path
                    d="M12.19 6.376a3.736 3.736 0 0 1 3.732-3.732 3.736 3.736 0 0 1 3.732 3.732 3.736 3.736 0 0 1-3.732 3.732 3.736 3.736 0 0 1-3.732-3.732zm2.488 0c0 .686.558 1.244 1.244 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.686 0-1.244.558-1.244 1.244zm7.463 8.645v5.473a3.738 3.738 0 0 1-2.487 3.519v6.743a1.244 1.244 0 1 1-2.488 0v-7.774c0-.687.557-1.244 1.244-1.244.685 0 1.244-.558 1.244-1.244v-5.473c0-.686-.559-1.244-1.244-1.244h-2.24a1.244 1.244 0 1 1 0-2.488h2.24a3.736 3.736 0 0 1 3.731 3.732zM0 12.533a3.736 3.736 0 0 1 3.732-3.732h4.975a3.736 3.736 0 0 1 3.732 3.732v6.78c0 .463-.086.908-.24 1.318a1.245 1.245 0 0 0 1.235 1.107c.687 0 1.244.557 1.244 1.244v7.774a1.244 1.244 0 0 1-2.488 0v-6.743a3.75 3.75 0 0 1-1.804-1.37c-.14.072-.285.135-.435.188v7.925a1.244 1.244 0 1 1-2.488 0V21.8c0-.687.557-1.244 1.244-1.244.686 0 1.244-.558 1.244-1.244v-6.779c0-.686-.558-1.244-1.244-1.244H3.732c-.686 0-1.244.558-1.244 1.244v6.78c0 .685.558 1.243 1.244 1.243.687 0 1.244.557 1.244 1.244v8.956a1.244 1.244 0 1 1-2.488 0v-7.912A3.739 3.739 0 0 1 0 19.325zm2.488-8.645A3.736 3.736 0 0 1 6.219.156a3.736 3.736 0 0 1 3.732 3.732A3.736 3.736 0 0 1 6.22 7.62a3.736 3.736 0 0 1-3.731-3.732zm2.488 0c0 .686.558 1.244 1.243 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.685 0-1.243.558-1.243 1.244z"
                  ></path>
                </g>
              </g>
            </svg>
            <span>{{
              !represented_pers.crm ? "Otvori CRM" : "CRM aktivan"
            }}</span>
          </div>
          <div
            v-if="link_inhouse_available && availableForInhouse"
            class="add-inhouse-btn add-pen"
            @click="!main_loading ? addOpenInhouseCase() : ''"
          >
            <svg
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.2959 7.10335V7.24558C13.2959 7.79893 12.9892 8.48251 12.4958 9.03009C11.9345 9.65233 11.2424 9.99456 10.5468 9.99456C9.85122 9.99456 9.15917 9.65233 8.59824 9.03009C8.10488 8.48251 7.79819 7.79893 7.79819 7.24558V7.10335L9.79566 3.77391L7.6724 2.93121C7.56662 3.03388 7.4435 3.11788 7.30927 3.17789V10.4826H8.60358L9.86233 13H3.72947L4.98822 10.4826H6.28253V3.17789C6.14803 3.11745 6.02514 3.03397 5.91939 2.93121L3.79614 3.77346L5.79405 7.10335V7.24558C5.79405 7.79893 5.48736 8.48251 4.994 9.03009C4.43263 9.65233 3.74058 9.99456 3.04498 9.99456C2.34937 9.99456 1.65732 9.65233 1.0964 9.03009C0.603031 8.48251 0.295898 7.79893 0.295898 7.24558V7.10335L2.69428 3.10633L5.53848 1.9774C5.54844 1.7434 5.62331 1.51679 5.75471 1.32291C5.88611 1.12903 6.06887 0.975532 6.28253 0.879586V0H7.30927V0.88003C7.52301 0.975913 7.70586 1.12938 7.83734 1.32327C7.96883 1.51715 8.04376 1.7438 8.05376 1.97785L10.8975 3.10633L13.2959 7.10335ZM12.1269 7.75893H8.96671C9.10261 8.03856 9.28883 8.29078 9.51608 8.50296C9.7441 8.71496 10.1086 8.96742 10.5468 8.96742C10.9851 8.96742 11.3495 8.71496 11.578 8.50296C11.8051 8.29075 11.9912 8.03854 12.1269 7.75893V7.75893ZM11.8758 6.73223L10.5468 4.51749L9.21784 6.73179L11.8758 6.73223ZM8.20088 11.9733L7.96887 11.5097H5.62293L5.39091 11.9733H8.20088ZM6.56433 2.02896C6.56436 2.05943 6.57039 2.08959 6.58207 2.11773C6.59376 2.14586 6.61087 2.17142 6.63244 2.19295C6.65401 2.21447 6.6796 2.23154 6.70776 2.24317C6.73592 2.2548 6.7661 2.26077 6.79657 2.26074C6.82703 2.26071 6.8572 2.25468 6.88534 2.243C6.91348 2.23131 6.93904 2.2142 6.96056 2.19263C6.98208 2.17107 6.99915 2.14548 7.01078 2.11732C7.02242 2.08916 7.02839 2.05898 7.02836 2.02851C7.0283 1.96698 7.0038 1.90799 6.96025 1.86452C6.91669 1.82106 6.85766 1.79667 6.79612 1.79673C6.73459 1.79679 6.6756 1.82129 6.63213 1.86484C6.58866 1.90839 6.56427 1.96743 6.56433 2.02896V2.02896ZM2.01424 8.50296C2.24225 8.71496 2.60672 8.96742 3.04498 8.96742C3.48323 8.96742 3.8477 8.71496 4.07616 8.50296C4.30325 8.29075 4.48933 8.03853 4.62508 7.75893H1.46487C1.60072 8.03859 1.78695 8.29081 2.01424 8.50296V8.50296ZM4.37396 6.73179L3.04498 4.51749L1.716 6.73179H4.37396Z"
                fill="#1B2FE9"
              />
            </svg>

            <span>{{ inhouse_text }}</span>
          </div>
          <div
            v-if="isFizicka || isPravna"
            class="add-inhouse-btn white state-report-btn"
            @click="generateCasesState()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              <path
                d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297"
                stroke="#2B2B41"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <circle
                cx="17.9954"
                cy="3.20027"
                r="1.9222"
                stroke="#2B2B41"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></circle>
              <path
                d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788"
                stroke="#2B2B41"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            <span>{{ $t("person_page.case_state_report") }}</span>
          </div>
        </div>
        <div
          class="upload-dokumenta-button case-tab-buttons-wrapper"
          v-if="!link_inhouse_available && availableForInhouse"
          @click="!main_loading ? addOpenInhouseCase() : ''"
        >
          {{ inhouse_text }}
          <div class="upload-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>

        <div
          class="upload-dokumenta-button case-tab-buttons-wrapper"
          v-if="!link_inhouse_available && availableForInhouse"
          @click="!main_loading ? addOpenInhouseCase() : ''"
        >
          {{ inhouse_text }}
          <div class="upload-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>

        <!-- <div @click="deletePerson"> Deletni</div> -->
      </div>
    </div>

    <div class="case-predmet osobe-profile">
      <div class="case-predmet-left">
        <crm-info
        v-if="represented_pers.crm"
          :person_crm_data="represented_pers.crm"
          :person_type="isFizicka ? 'phys' : 'leg'"
          @refreshData="refreshData"
          :person_id="person_id"
        ></crm-info>

        <box-files
          v-if="represented_pers.crm && !main_loading"
          :all_files="represented_pers.crm.supporting_documents_array"
          @update = "refreshData"
          :title="'Ugovori'"
          :person_type="isFizicka ? 'phys' : 'leg'"
          :person_id="person_id"
        ></box-files>

        <div class="crm-naplata section person-cases-section">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39256,0.39255h31.60739c5.52285,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47714,10.00008 -9.99999,10.00008h-31.60739c-5.52285,0 -9.99999,-4.47723 -9.99999,-10.00008v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#f1f0ff"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>slucajevi</title>
                    <path
                      d="M41.2481,27.73258v0.32008c0,1.24517 -0.6901,2.78386 -1.80101,4.01527c-1.26219,1.39922 -2.81906,2.16982 -4.38404,2.16982c-1.56486,0 -3.12185,-0.7706 -4.38404,-2.16982c-1.11091,-1.2314 -1.80089,-2.7701 -1.80089,-4.01527v-0.32008l4.49455,-7.49105l-4.77695,-1.89516c-0.23818,0.23112 -0.5151,0.41941 -0.81646,0.55468v16.43541h2.91193l2.83182,5.66357h-13.79788l2.8317,-5.66357h2.91204v-16.43568c-0.30136,-0.135 -0.57828,-0.3233 -0.81646,-0.5545l-4.77695,1.89516l4.49467,7.49114v0.32008c0,1.24517 -0.6901,2.78386 -1.80101,4.01527c-1.26219,1.39922 -2.81918,2.16982 -4.38404,2.16982c-1.56486,0 -3.12185,-0.7706 -4.38404,-2.16982c-1.11091,-1.2314 -1.80101,-2.7701 -1.80101,-4.01527v-0.32008l5.39565,-8.99273l6.39904,-2.53871c0.04375,-1.07378 0.69749,-2.03231 1.67418,-2.46996v-1.97911h2.3104v1.97911c0.97668,0.43765 1.63054,1.39618 1.67429,2.46996l6.39892,2.53871zM38.61798,29.20779h-7.10988c0.28431,0.59813 0.72646,1.20118 1.23584,1.67415c0.51355,0.47699 1.33276,1.04544 2.3191,1.04544c0.98634,0 1.80566,-0.56845 2.31922,-1.04544c0.50938,-0.47296 0.95153,-1.07601 1.23572,-1.67415zM38.05269,26.89743l-2.98965,-4.98283l-2.98965,4.98283zM29.78481,38.68976l-0.52142,-1.04302h-5.27859l-0.52154,1.04302zM26.10256,16.31629c0,0.28744 0.23401,0.52133 0.52154,0.52133c0.28741,0 0.52142,-0.23389 0.52142,-0.52133c0,-0.28762 -0.23401,-0.52169 -0.52142,-0.52169c-0.28753,0 -0.52154,0.23407 -0.52154,0.52169zM15.86582,30.88194c0.51355,0.47699 1.33288,1.04544 2.31922,1.04544c0.98634,0 1.80554,-0.56845 2.31922,-1.04544c0.50926,-0.47296 0.95141,-1.07601 1.2356,-1.67415h-7.10976c0.28419,0.59813 0.72634,1.20118 1.23572,1.67415zM21.17468,26.89743l-2.98965,-4.98283l-2.98965,4.98283z"
                      fill="#1e33f2"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            {{ $t("person_page.cases_title") }}
            <div class="generiraj-rocisnik-button" @click="openReport()">
              <span>{{ $t("person_page.report") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
              >
                <path
                  d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297"
                  stroke="#2B2B41"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <circle
                  cx="17.9954"
                  cy="3.20027"
                  r="1.9222"
                  stroke="#2B2B41"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></circle>
                <path
                  d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788"
                  stroke="#2B2B41"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </div>
          </div>

          <div
            :class="[
              popis_predmeta.length > 5 ? 'person-cases-wrapper' : '',
              'person-all-cases',
            ]"
          >
            <div
              class="case-info-item single-row-case"
              v-for="(predmet, key) of finalni_arr_prikaza"
              :key="key"
            >
            <div
                :class="[
                  'zadnji-spis-dot',
                  'indikator',
                  !predmet.predmet.is_archived ? 'i-g' : predmet.predmet.is_archived && !predmet.predmet.is_destroyed ? 'i-g-archived' : 'i-g-destroyed'
                ]"
              >
              </div>
              <div class="case-info-item-title">
                {{ predmet.predmet.broj_predmeta }}
              </div>
              <div class="case-info-item-info">
                <router-link :to="'/case/' + predmet.predmet.group_url + '/'"
                  >{{ predmet.predmet.ime_predmeta }}
                </router-link>
              </div>
                
            </div>
          </div>
          <Pagination
            v-show="popis_predmeta.length > br_redova"
            ref="paginat"
            :finalni_arr_prikaza.sync="finalni_arr_prikaza"
            :br_redova="br_redova"
            :ukupna_lista="popis_predmeta"
          />
        </div>
        <div
          v-if="!isInstitucija && !isLegBody"
          class="crm-naplata section person-cases-section"
        >
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="43"
                height="42"
                viewBox="0 0 43 42"
                fill="none"
              >
                <rect width="43" height="42" rx="10" fill="#F2F2F2" />
                <path
                  d="M33.99 17.3308L32.717 30.4265C32.6582 31.3075 31.8833 32 30.9527 32H13.0472C12.1625 32 11.4058 31.3382 11.2864 30.4606L11.283 30.4273L10.0099 17.3274C9.96668 17.005 10.0661 16.6732 10.2823 16.4216C10.3974 16.2879 10.5407 16.1806 10.7021 16.1071C10.8636 16.0336 11.0394 15.9957 11.2172 15.996H12.204L11.871 13.863C11.814 13.5236 11.9143 13.1722 12.1495 12.8976C12.383 12.6264 12.7203 12.4712 13.0749 12.4712H14.6688L14.3384 10.3944C14.3107 10.223 14.3213 10.0476 14.3694 9.88054C14.4175 9.71351 14.502 9.55883 14.6169 9.42728C14.8504 9.15607 15.1877 9 15.5423 9H28.4862C28.8408 9 29.1764 9.1501 29.4073 9.41279C29.639 9.67632 29.742 10.0303 29.6909 10.3833L29.3407 12.4694H30.9527C31.3073 12.4694 31.642 12.6195 31.8729 12.8822C32.1047 13.1449 32.2085 13.498 32.1574 13.8511L31.8228 15.9952H32.7827C33.1451 15.9952 33.4858 16.1504 33.7185 16.4216C33.9347 16.6724 34.0333 17.0041 33.99 17.3299V17.3308ZM16.5654 12.4703H27.4415L27.7131 10.8473H16.3076L16.5654 12.4703ZM14.1006 15.996H29.927L30.1891 14.3185H13.8385L14.1006 15.996ZM32.058 17.8433H11.942L13.1389 30.1553L30.8619 30.1527L32.058 17.8433ZM17.5703 22.0846C17.5703 21.5755 17.9906 21.161 18.5078 21.161H25.4922C26.0093 21.161 26.4296 21.5755 26.4296 22.0846C26.4296 22.5938 26.0093 23.0083 25.4922 23.0083H18.5078C18.2593 23.0083 18.021 22.911 17.8452 22.7378C17.6694 22.5646 17.5705 22.3297 17.5703 22.0846V22.0846Z"
                  fill="black"
                />
              </svg>
            </div>
            {{ $t("person_page.projects_title") }}
          </div>
          <div
            :class="[
              popis_projekata.length > 5 ? 'person-cases-wrapper' : '',
              'person-all-cases',
            ]"
          >
            <div
              class="case-info-item"
              v-for="(projekt, key) of finalni_arr_prikaza_proj"
              :key="key"
            >
              <div class="case-info-item-title">
                {{ projekt.project.broj_projekta }}
              </div>
              <div class="case-info-item-info">
                <router-link
                  :to="'/projects/' + projekt.project.group_url + '/'"
                  >{{ projekt.project.name }}
                </router-link>
              </div>
            </div>
          </div>
          <Pagination
            v-show="popis_projekata.length > br_redova"
            ref="paginat_proj"
            :finalni_arr_prikaza.sync="finalni_arr_prikaza_proj"
            :br_redova="br_redova"
            :ukupna_lista="popis_projekata"
          />
        </div>
        <div class="crm-komunikacija section" v-if="isFizicka">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                width="52"
                height="52"
                viewBox="-5.6 -5.6 27.20 27.20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0">
                  <rect
                    x="-5.6"
                    y="-5.6"
                    width="27.20"
                    height="27.20"
                    rx="5.44"
                    fill="#f1f0ff"
                    strokewidth="0"
                  ></rect>
                </g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path fill="#1e33f2" d="M8 4h-1v5h4v-1h-3z"></path>
                  <path
                    fill="#1e33f2"
                    d="M8 0c-3 0-5.6 1.6-6.9 4.1l-1.1-1.1v4h4l-1.5-1.5c1-2 3.1-3.5 5.5-3.5 3.3 0 6 2.7 6 6s-2.7 6-6 6c-1.8 0-3.4-0.8-4.5-2.1l-1.5 1.3c1.4 1.7 3.6 2.8 6 2.8 4.4 0 8-3.6 8-8s-3.6-8-8-8z"
                  ></path>
                </g>
              </svg>
            </div>
            {{ $t("person_page.user_log_title") }}
          </div>
          <div class="case-info-item" v-if="loading_flag_cp_log">
            <div class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="5"
                ></circle>
              </svg>
            </div>
          </div>
          <div
            v-if="!loading_flag_cp_log && cp_log_all.length == 0"
            class="case-info-item"
          >
            <span>{{ $t("person_page.user_log_text_handle") }}</span>
          </div>

          <div
            class="case-info-item communication-element"
            v-for="(ul, key) in cp_log_cur_view"
            :key="key"
          >
            <div class="case-info-item-title">
              <div>{{ switchDate(ul.added) }}</div>
              {{ switchTime(ul.added) }}
            </div>
            <div class="case-info-item-info">
              <div class="prilog-mail">
                <span>{{ ul.title }}</span>
              </div>
              <div class="prilog-details-wrapper">
                <div class="prilog-details" v-if="ul.odvjetnik">
                  Član tima:
                  <span>{{ ul.odvjetnik.ime }} {{ ul.odvjetnik.prezime }}</span>
                </div>
                <div class="prilog-details" v-if="ul.case_id">
                  {{ $t("person_page.com_file.case") }}
                  <router-link :to="'/case/' + ul.predmet.group_url + '/'">{{
                    ul.predmet.ime_predmeta
                  }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            v-show="cp_log_all.length > br_redova"
            ref="paginat_cp_log"
            :finalni_arr_prikaza.sync="cp_log_cur_view"
            :br_redova="br_redova_kom"
            :ukupna_lista="cp_log_all"
          />
        </div>

        <div class="crm-komunikacija section">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39256,0.39256h31.60739c5.52285,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47714,9.99999 -9.99999,9.99999h-31.60739c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#fef2e2"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 545</title>
                    <path
                      d="M39.59622,18.21092v15.46875c0,1.28245 -1.05345,2.32038 -2.33757,2.32038h-21.92104c-1.29199,0 -2.33757,-1.0457 -2.33757,-2.32038v-15.46875c0,-1.27888 1.05023,-2.32029 2.33757,-2.32029h21.92104c1.29199,0 2.33757,1.0457 2.33757,2.32029zM15.66793,17.43755l10.67972,10.51006l10.58829,-10.51006zM22.06339,25.90966l-7.50506,-7.38573v14.83548zM36.93594,34.45312l-7.46918,-7.41398l-2.56574,2.54676c-0.30339,0.30121 -0.79489,0.3022 -1.09947,0.00241l-2.63143,-2.58958l-7.50983,7.4544zM38.03791,18.53126l-7.46918,7.41407l7.46918,7.41398z"
                      fill="#fe9923"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            {{ $t("person_page.communication_title") }}
          </div>
          <div class="case-info-item" v-if="loading_flag">
            <div class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="5"
                ></circle>
              </svg>
            </div>
          </div>
          <div
            v-if="!loading_flag && finalni_arr_prikaza_kom.length == 0"
            class="case-info-item"
          >
            <span>{{ comunication_text_handle }}</span>
          </div>

          <div
            class="case-info-item communication-element"
            v-for="(com, key) in finalni_arr_prikaza_kom"
            :key="key"
            @click="openFile(com.webUrl)"
          >
            <div class="case-info-item-title">
              {{ switchDate(com.lastModifiedDateTime) }}
            </div>
            <div class="case-info-item-info">
              <div class="prilog-mail">
                <span class="prilog-mail-title">{{ com.name }}</span>
              </div>
              <div class="prilog-details-wrapper">
                <div class="prilog-details">
                  {{ $t("person_page.com_file.upload") }}
                  <span>{{ com.createdBy.user.displayName }}</span>
                </div>
                <div class="prilog-details">
                  {{ $t("person_page.com_file.case") }}
                  <span>{{ com.predmet }}</span>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            v-show="all_comm.length > br_redova"
            ref="paginat_kom"
            :finalni_arr_prikaza.sync="finalni_arr_prikaza_kom"
            :br_redova="br_redova_kom"
            :ukupna_lista="all_comm"
          />
        </div>
      </div>
      <!-- Close case-predmet-left -->
      <div class="case-predmet-right">
        <div class="crm-info section osobe-profile-info">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39255,0.39254h31.60751c5.52273,0 9.99999,4.47723 9.99999,10.00008v31.60742c0,5.52285 -4.47726,9.99999 -9.99999,9.99999h-31.60751c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-10.00008 9.99999,-10.00008z"
                      fill="#feedf3"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 546</title>
                    <path
                      d="M39.00004,21.41668v10.23996c0,4.43539 -2.8547,7.41667 -7.10595,7.41667h-10.86664c-4.24743,0 -7.10082,-2.98128 -7.10082,-7.41667v-10.23996c0,-4.43548 2.85339,-7.41667 7.10082,-7.41667h10.86915c4.24874,0 7.10344,2.98119 7.10344,7.41667zM37.11951,21.41668c0,-3.36358 -2.051,-5.53617 -5.22292,-5.53617h-10.86915c-3.17049,0 -5.22029,2.17259 -5.22029,5.53617v10.23996c0,3.36358 2.0498,5.53617 5.22029,5.53617h10.86664c3.17442,0 5.22542,-2.17259 5.22542,-5.53617zM27.39597,26.53666v5.01466c0,0.51901 -0.42129,0.94029 -0.94032,0.94029c-0.5188,0 -0.9402,-0.42129 -0.9402,-0.94029v-5.01466c0,-0.51901 0.4214,-0.9402 0.9402,-0.9402c0.51904,0 0.94032,0.4212 0.94032,0.9402zM27.71569,21.77788c0,0.69326 -0.56052,1.25366 -1.25372,1.25366c-0.69344,0 -1.25992,-0.5604 -1.25992,-1.25366c0,-0.69326 0.5554,-1.25366 1.24741,-1.25366h0.01252c0.6932,0 1.25372,0.5604 1.25372,1.25366z"
                      fill="#fd4087"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            {{ $t("person_page.info_title") }}
          </div>
          <div class="crm-info-part">
            <div v-if="!isLegBody" class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.oib") }}
              </div>
              <div class="case-info-item-info">
                {{ represented_pers.oib }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.uloga") }}
              </div>
              <div class="case-info-item-info">
                {{ represented_pers.uloga }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.date") }}
              </div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.datum_unosa != null"
              >
                {{ switchDate(represented_pers.datum_unosa) }}
              </div>
            </div>
            <div class="case-info-item" v-if="isFizicka">
              <div class="case-info-item-title">
                {{ $t("person_page.info.bday") }}
              </div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.rodjendan != null"
              >
                {{ switchDate(represented_pers.rodjendan) }}
              </div>
            </div>
          </div>
          <div v-if="!isInstitucija && !isLaw" class="crm-info-part">
            <div v-if="!isLegBody" class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.industry") }}
              </div>
              <div
                v-if="represented_pers.industrija_id"
                class="case-info-item-info"
              >
                {{
                  represented_pers.industrija_id.naziv[0].toUpperCase() +
                  represented_pers.industrija_id.naziv.slice(1)
                }}
              </div>
            </div>
            <div v-if="!isLegBody" class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.income") }}
              </div>
              <div class="case-info-item-info">
                {{ represented_pers.god_prihod }}
              </div>
            </div>
            <div class="case-info-item" v-if="isLegBody">
              <div class="case-info-item-title">
                {{ $t("person_page.info.institucija") }}
              </div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.institucija"
              >
                <router-link
                  :to="'/osobe/institucije/' + represented_pers.institucija.uid"
                  >{{ represented_pers.institucija.naziv }}</router-link
                >
              </div>
            </div>
          </div>
          <div class="crm-info-part">
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.emails") }}
              </div>
              <div class="case-info-item-info">
                <div
                  v-for="(singleMail, key) in represented_pers.email_list"
                  :key="key"
                >
                  {{ singleMail }}
                </div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.phones") }}
              </div>
              <div class="case-info-item-info">
                <div
                  v-for="(singleTel, key) in represented_pers.tel_br_list"
                  :key="key"
                >
                  {{ singleTel }}
                </div>
              </div>
            </div>

            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.addresses") }}
              </div>
              <div class="case-info-item-info">
                <div
                  v-for="(singleAdd, key) in represented_pers.adresa"
                  :key="key"
                >
                  {{ singleAdd.adresa + ", " }}{{ singleAdd.post_br + ", "
                  }}{{ singleAdd.grad + ", " }}{{ singleAdd.drzava }}
                </div>
              </div>
            </div>

            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.web_pages") }}
              </div>
              <div class="case-info-item-info">
                <div
                  v-for="(stranica, key) in represented_pers.web_list"
                  :key="key"
                >
                  {{ stranica }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isInstitucija" class="crm-info-part">
            <div v-if="!isLegBody && !isLaw" class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.tip_izvora") }}
              </div>
              <div
                v-if="represented_pers.id_tip_izvora"
                class="case-info-item-info"
              >
                {{ represented_pers.id_tip_izvora.naziv }}
              </div>
            </div>
            <div v-if="!isLegBody && !isLaw" class="case-info-item">
              <div
                class="case-info-item-title"
                v-if="
                  represented_pers.id_tip_izvora &&
                  represented_pers.id_tip_izvora.id_tip_izvora != 5
                "
              >
                {{ $t("person_page.info.izvor") }}
              </div>
              <div
                v-if="represented_pers.id_tip_izvora"
                class="case-info-item-info"
                v-html="getCorrectName()"
              ></div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("person_page.info.upisan") }}
              </div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.upisan_od"
              >
                <router-link
                  :to="'/osobe/law/' + represented_pers.upisan_od.uid"
                  >{{ represented_pers.upisan_od.ime }}
                  {{ represented_pers.upisan_od.prezime }}</router-link
                >
              </div>
            </div>
          </div>
          <div v-if="isPravna" class="case-info-item">
            <div class="case-info-item-title">
              {{ $t("person_page.info.izvod") }}
            </div>
            <div
              @click="
                getAttachment(
                  represented_pers.izvod_sud_reg.id,
                  represented_pers.izvod_sud_reg.name
                )
              "
              v-if="
                represented_pers.izvod_sud_reg &&
                represented_pers.izvod_sud_reg.id != undefined
              "
              class="case-info-item-info person-izvod"
            >
              <img src="@/assets/img/pdf_icon.svg" />
              <span>{{ represented_pers.izvod_sud_reg.name }}</span>
            </div>
          </div>
        </div>
        <div class="crm-naplata section" v-if="visible_work">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39255,0.39259h31.60751c5.52273,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47726,9.99999 -9.99999,9.99999h-31.60751c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#e2fefa"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 547</title>
                    <path
                      d="M38.41114,25.79445c0,6.7302 -5.47528,12.20557 -12.2056,12.20557c-6.7302,0 -12.2056,-5.47528 -12.2056,-12.20557c0,-6.73029 5.4754,-12.20557 12.2056,-12.20557c6.73032,0 12.2056,5.47528 12.2056,12.20557zM35.74324,25.79445c0,-5.25901 -4.27842,-9.53776 -9.5377,-9.53776c-5.25916,0 -9.5377,4.27875 -9.5377,9.53776c0,5.25919 4.27854,9.53767 9.5377,9.53767c5.25928,0 9.5377,-4.27848 9.5377,-9.53767zM30.81036,29.35714c0.40388,0.40367 0.40364,1.0584 0,1.46234c-0.40364,0.40394 -1.05834,0.40394 -1.46222,0l-3.85118,-3.85085c-0.2147,-0.21476 -0.31161,-0.50023 -0.29802,-0.78142c-0.00072,-0.01627 -0.00477,-0.03156 -0.00477,-0.04783v-5.44596c0,-0.57122 0.46289,-1.03408 1.03402,-1.03408c0.57101,0 1.0339,0.46286 1.0339,1.03408v5.1156z"
                      fill="#0acab1"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            {{ $t("person_page.info.worktime") }}
          </div>
          <!-- <div class="edit-info add-button add-pen">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  />
                </g>
              </g>
            </svg>
          </div> -->
          <div class="case-info-item radno-vrijeme-item">
            <!-- <div class="case-info-item-title">Pon-pet</div> -->
            <div class="case-info-item-info">
              {{ represented_pers.radno_vrijeme }}
            </div>
          </div>
          <!-- <div class="case-info-item radno-vrijeme-item">
            <div class="case-info-item-title">Za stranke</div>
            <div class="case-info-item-info">08:00 - 16:00</div>
          </div> -->
        </div>
        <div class="crm-opis section">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39255,0.39257h31.60751c5.52273,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47726,9.99999 -9.99999,9.99999h-31.60751c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#faeafd"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 548</title>
                    <path
                      d="M25.88714,40.99997c-1.53363,0 -2.63083,-1.15326 -3.50976,-2.07594c-0.37408,-0.45446 -0.82111,-0.84409 -1.32167,-1.15326c-0.61095,-0.15208 -1.24311,-0.20072 -1.87027,-0.14341c-1.32167,0 -2.81155,0.04989 -3.85892,-0.99126c-1.04737,-1.04105 -0.98503,-2.53102 -0.95999,-3.85264c0.05853,-0.62719 0.01001,-1.2593 -0.14341,-1.8703c-0.30923,-0.5005 -0.6988,-0.94754 -1.15335,-1.32161c-0.89777,-0.84785 -2.06971,-1.94505 -2.06971,-3.47874c0,-1.5336 1.17195,-2.6308 2.06971,-3.50976c0.45443,-0.37408 0.844,-0.82111 1.15335,-1.3217c0.1533,-0.61092 0.20194,-1.24303 0.14341,-1.87021c0,-1.31544 -0.04995,-2.81158 0.99123,-3.85273c1.04105,-1.04105 2.53725,-1.01611 3.85892,-0.99117c0.62716,0.05856 1.25921,0.01055 1.87016,-0.14341c0.50068,-0.30917 0.947,-0.6988 1.32167,-1.15326c0.84782,-0.87288 1.94502,-2.04492 3.47865,-2.04492c1.53363,0 2.63083,1.17204 3.50988,2.07603c0.37396,0.45446 0.82099,0.84409 1.32155,1.15326c0.61095,0.15333 1.24311,0.20197 1.87027,0.14341c1.32167,0 2.81155,-0.04989 3.85892,0.99117c1.04737,1.04114 1.01614,2.53728 0.99123,3.85273c-0.05865,0.62719 -0.01001,1.2593 0.14341,1.87021c0.30923,0.50059 0.6988,0.94762 1.15323,1.3217c0.86665,0.84785 2.03872,1.94505 2.03872,3.47865c0,1.53369 -1.17207,2.63089 -2.06983,3.50985c-0.45443,0.37408 -0.844,0.82111 -1.15323,1.32161c-0.1533,0.61101 -0.20194,1.24311 -0.14341,1.8703c0,1.31544 0.04995,2.81158 -0.99123,3.85264c-1.04105,1.04114 -2.53725,1.0162 -3.85892,0.99126c-0.62716,-0.05919 -1.25933,-0.01055 -1.87027,0.14341c-0.50056,0.30917 -0.94688,0.6988 -1.32155,1.15326c-0.84794,0.87288 -1.94514,2.04483 -3.47877,2.04483zM19.79018,35.04636c0.76556,-0.03487 1.53041,0.08163 2.25055,0.34288c0.84472,0.42647 1.59156,1.02299 2.1944,1.75184c0.54228,0.5672 1.24681,1.27798 1.6458,1.27798c0.39899,0 1.1034,-0.7107 1.6458,-1.27798c0.60284,-0.72885 1.34969,-1.32537 2.1944,-1.75184c0.92447,-0.30801 1.9033,-0.42209 2.8739,-0.33662c0.72312,0 1.72067,0 1.98865,-0.23693c0.2681,-0.23693 0.24939,-1.24687 0.23699,-1.98877c-0.08547,-0.9706 0.02861,-1.94934 0.33665,-2.8739c0.42641,-0.84472 1.02305,-1.59153 1.75178,-2.1944c0.56732,-0.54234 1.27804,-1.24687 1.27804,-1.6458c0,-0.39902 -0.71073,-1.10346 -1.27804,-1.6458c-0.72873,-0.60278 -1.32537,-1.34969 -1.75178,-2.1944c-0.30804,-0.92456 -0.42272,-1.9033 -0.33665,-2.8739c0,-0.72321 0,-1.72064 -0.23699,-1.98877c-0.23687,-0.26804 -1.24681,-0.25553 -1.98865,-0.23684c-0.9706,0.08538 -1.94883,-0.02933 -2.8739,-0.33671c-0.84472,-0.42638 -1.59156,-1.02299 -2.1944,-1.75175c-0.5424,-0.56729 -1.24693,-1.27807 -1.6458,-1.27807c-0.39899,0 -1.10352,0.7107 -1.6458,1.27807c-0.60296,0.72876 -1.34969,1.32537 -2.1944,1.75175c-0.92518,0.30738 -1.9033,0.42209 -2.87402,0.33671c-0.72312,0 -1.72055,0 -1.98865,0.23684c-0.2681,0.23693 -0.24939,1.24687 -0.23687,1.98877c0.08535,0.9706 -0.02873,1.94934 -0.33665,2.8739c-0.42653,0.84472 -1.02305,1.59162 -1.7519,2.1944c-0.5672,0.54243 -1.27804,1.24687 -1.27804,1.6458c0,0.39902 0.71073,1.10346 1.27804,1.6458c0.72885,0.60287 1.32537,1.34969 1.7519,2.1944c0.30792,0.92456 0.4226,1.9033 0.33665,2.8739c0,0.72321 0,1.72064 0.23687,1.98877c0.23687,0.26804 1.24681,0.24936 1.98865,0.23693z"
                      fill="#a131d0"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            {{ $t("person_page.info.description") }}
          </div>
          <p>{{ represented_pers.opis }}</p>
        </div>
      </div>
      <!-- Close case-predmet-right -->
    </div>
    <v-dialog v-model="inhouse_create_popup" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("person_page.warning") }}
        </div>
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="inhouse_create_popup = false"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="!main_loading ? createInhouse() : ''"
          >
            {{ $t("repetitive.create") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- Close case-predmet -->
  </div>
</template>

<script>
import auth from "@/services/auth";
import Spisi from "@/components/caseComponents/Spisi.vue";
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import institucije from "@/apiCallers/promise_handler_db/institucije";
import moment from "moment";
import DataLoader from "@/components/generalComponents/DataLoader";
import default_img from "@/assets/img/default-image.png";
import Pagination from "@/components/generalComponents/Pagination.vue";
import predmeti_handle from "@/apiCallers/promise_handler_db/predmeti";
import avatarService from "@/services/avatarService";
import graph from "@/services/graph";

import {
  createPhysPerson,
  createLegalPerson,
} from "../../../../apiCallers/promise_handler_db/crm";
import BoxFiles from "../../../../components/generalComponents/BoxFiles.vue";
import CrmInfo from '../../../../components/crm/CrmInfo.vue';

export default {
  components: {
    Spisi,
    DataLoader,
    Pagination,
    BoxFiles,
    CrmInfo,
  },
  data() {
    return {
      person_id: "",
      person_type : "",
      accessToken: "",
      represented_pers: {},
      all_comm: [],
      edit_pers: undefined,
      popis_predmeta: [],
      popis_projekata: [],
      visible_work: true,
      isFizicka: false,
      isPravna: false,
      isInstitucija: false,
      isLegBody: false,
      isLaw: false,
      komunikacija: [],
      comunication_text_handle: this.$t("person_page.comunication_text_handle"),
      loading_flag: true,
      loading_flag_cp_log: true,
      br_redova: 4,
      br_redova_kom: 4,
      finalni_arr_prikaza: [],
      finalni_arr_prikaza_proj: [],
      main_loading: true,
      finalni_arr_prikaza_kom: [],
      imgErr: false,
      inhouse_link: undefined,
      inhouse_create_popup: false,

      //logs client portal
      cp_log_cur_view: [],
      cp_log_all: [],
      //logs client portal

      // Avatar from MS Graph
      avatarUrl: null,
    };
  },
  computed: {
    getAvatar() {
      // Use MS Graph avatar if available
      if (this.avatarUrl) {
        return this.avatarUrl;
      }
      // Fallback to default image
      return default_img;
    },
    inhouse_text: function () {
      if (this.link_inhouse_available) {
        return this.$t("person_page.link_inhouse_available1");
      } else {
        return this.$t("person_page.link_inhouse_available2");
      }
    },
    link_inhouse_available: function () {
      return this.inhouse_link != undefined && this.inhouse_link != null;
    },

    availableForInhouse() {
      return (
        !this.isLaw &&
        ((this.represented_pers.uloga &&
          this.represented_pers.uloga.includes("Stranka")) ||
          this.popis_predmeta.length == 0)
      );
    },
    availableForCRM() {
      return this.isFizicka || this.isLegBody;
    },
  },
  async created() {
  await this.refreshData()

   document.body.classList.add("osobe-profil");
    // console.log(this.accessToken)
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
      }
    },
  },
  methods: {
    refreshData()
    {
      this.main_loading = true;
      this.accessToken = this.$store.state.aToken;

var uid = this.$route.fullPath.split("/")[3];
this.person_id = this.$route.fullPath.split("/")[3];
this.$store.state.paginacija.back_link = "/osobe";
switch (this.$route.fullPath.split("/")[2]) {
  case "fiz":
    this.isFizicka = true;
    //ovo treba razdvojiti
    osoba.getSingleStrankaProtustranka(uid).then((response) => {
      this.main_loading = false;
      console.log(response.data, "Fizička osoba");
      this.cp_log_all = response.data.client_portal_user_logs;
      setTimeout(() => {
        this.$refs.paginat_cp_log.calculatePageNumber();
        this.$refs.paginat_cp_log.paginirajOdabrane();
        this.loading_flag_cp_log = false;
      }, 150);
      this.represented_pers = response.data;
      this.popis_predmeta = response.data.predmeti;
      this.inhouse_link = this.popis_predmeta.find(
        (p) => p.predmet.predmet_type == 2
      );
      this.popis_projekata = response.data.projekti;
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
        this.$refs.paginat_proj.calculatePageNumber();
        this.$refs.paginat_proj.paginirajOdabrane();
      }, 50);
      this.edit_pers = response.data;
      this.$store.state.paginacija.title = this.$t(
        "breadcrumbs.person_profile.physical"
      );
      this.$store.state.paginacija.subpages = [
        this.represented_pers.ime + " " + this.represented_pers.prezime,
      ];
    });
    osoba.getPhisPersCommunication(uid).then((response) => {
      this.komunikacija = response.data;
      this.all_comm = [];
      for (let i = 0; i < this.komunikacija.length; i++) {
        this.all_comm.push(
          ...this.komunikacija[i].file_list.map((el) => ({
            ...el,
            predmet: this.komunikacija[i].predmet,
          }))
        );
      }
      setTimeout(() => {
        this.$refs.paginat_kom.calculatePageNumber();
        this.$refs.paginat_kom.paginirajOdabrane();
        this.loading_flag = false;
      }, 50);
    });
    break;
  case "law":
    this.isLaw = true;
    osoba.getOdvjetnik(uid).then((response) => {
      this.main_loading = false;
      this.represented_pers = response.data;
      this.popis_predmeta = response.data.predmeti;
      this.popis_projekata = response.data.projekti;
      console.log(response.data);
      // Load avatar from MS Graph
      this.loadAvatar();
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
        this.$refs.paginat_proj.calculatePageNumber();
        this.$refs.paginat_proj.paginirajOdabrane();
      }, 50);
      this.$store.state.paginacija.title = this.$t(
        "breadcrumbs.person_profile.team_member"
      );
      this.$store.state.paginacija.subpages = [
        this.represented_pers.ime + " " + this.represented_pers.prezime,
      ];
    });
    osoba.getOdvjetnikComunication(uid).then((response) => {
      this.komunikacija = response.data;
      this.all_comm = [];
      for (let i = 0; i < this.komunikacija.length; i++) {
        this.all_comm.push(
          ...this.komunikacija[i].file_list.map((el) => ({
            ...el,
            predmet: this.komunikacija[i].predmet,
          }))
        );
      }
      setTimeout(() => {
        this.$refs.paginat_kom.calculatePageNumber();
        this.$refs.paginat_kom.paginirajOdabrane();
        this.loading_flag = false;
      }, 50);
    });
    // const odvjetnik_by_source = await osoba.getCasesBySource(uid);
    // console.log(odvjetnik_by_source);
    break;

  case "leg-body":
    this.isLegBody = true;
    osoba.get_single_legal_body(uid).then((response) => {
      this.main_loading = false;
      this.represented_pers = response.data;
      this.popis_predmeta = response.data.predmeti;
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
      }, 50);
      console.log(response.data);
      this.$store.state.paginacija.title = this.$t(
        "breadcrumbs.person_profile.sudionik"
      );
      this.$store.state.paginacija.subpages = [
        this.represented_pers.ime + " " + this.represented_pers.prezime,
      ];
    });
    osoba.getLegBodyComunication(uid).then((response) => {
      this.main_loading = false;
      this.komunikacija = response.data.komunikacija;
      this.all_comm = [];
      for (let i = 0; i < this.komunikacija.length; i++) {
        this.all_comm.push(
          ...this.komunikacija[i].file_list.map((el) => ({
            ...el,
            predmet: this.komunikacija[i].predmet,
          }))
        );
      }
      setTimeout(() => {
        this.$refs.paginat_kom.calculatePageNumber();
        this.$refs.paginat_kom.paginirajOdabrane();
      }, 50);
      this.loading_flag = false;
    });
    break;
  case "institucije":
    this.isInstitucija = true;
    institucije.getSingleInstitucija(uid).then((response) => {
      this.main_loading = false;
      this.represented_pers = response.data;
      this.popis_predmeta = response.data.predmeti;
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
      }, 50);
      this.$store.state.paginacija.title = this.$t(
        "breadcrumbs.person_profile.institution"
      );
      this.$store.state.paginacija.subpages = [this.represented_pers.naziv];
    });
    institucije.getSingleInstitucijaComunication(uid).then((response) => {
      this.komunikacija = response.data;
      this.all_comm = [];
      for (let i = 0; i < this.komunikacija.length; i++) {
        this.all_comm.push(
          ...this.komunikacija[i].file_list.map((el) => ({
            ...el,
            predmet: this.komunikacija[i].predmet,
          }))
        );
      }
      setTimeout(() => {
        this.$refs.paginat_kom.calculatePageNumber();
        this.$refs.paginat_kom.paginirajOdabrane();
        this.loading_flag = false;
      }, 50);
    });
    break;
  case "prav":
    //ovo treba razdvojiti
    this.isPravna = true;
    osoba.getPravna(uid).then((response) => {
      this.main_loading = false;
      this.represented_pers = response.data;
      this.popis_predmeta = response.data.predmeti;
      this.inhouse_link = this.popis_predmeta.find(
        (p) => p.predmet.predmet_type == 2
      );
      this.popis_projekata = response.data.projekti;
      console.log(this.represented_pers);
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
        this.$refs.paginat_proj.calculatePageNumber();
        this.$refs.paginat_proj.paginirajOdabrane();
      }, 50);
      this.edit_pers = response.data;
      this.$store.state.paginacija.title = this.$t(
        "breadcrumbs.person_profile.legal"
      );
      this.$store.state.paginacija.subpages = [this.represented_pers.ime];
    });
    osoba.getPravnaComunication(uid).then((response) => {
      this.komunikacija = response.data;
      this.all_comm = [];
      for (let i = 0; i < this.komunikacija.length; i++) {
        this.all_comm.push(
          ...this.komunikacija[i].file_list.map((el) => ({
            ...el,
            predmet: this.komunikacija[i].predmet,
          }))
        );
      }
      setTimeout(() => {
        this.$refs.paginat_kom.calculatePageNumber();
        this.$refs.paginat_kom.paginirajOdabrane();
        this.loading_flag = false;
      }, 50);
    });
    break;

  default:
    break;
}
    },
    // async deletePerson(){
    //   if (this.isFizicka) {
    //     await osoba.deleteFizicka(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/osobe")
    //     })
    //   }
    //   else if(this.isPravna){
    //     await osoba.deletePravna(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/osobe")
    //     })
    //   }
    //   else if(this.isLegBody){
    //     await osoba.deleteSluzbena(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/osobe")
    //     })
    //   }
    //   else if(this.isInstitucija){
    //     await institucije.deleteInstitucija(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/institucije")
    //     })
    //   }
    // },
    switchTime(ts_val) {
      return moment(ts_val).format("LT");
    },
    async getAttachment(attach_id, file_name) {
      this.accessToken = this.$store.state.aToken;
      await osoba.getIzvod(this.accessToken, attach_id).then((resp) => {
        //pripremanje download linka
        var link = document.createElement("a");
        link.setAttribute("href", resp.data.webUrl);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", file_name);
        link.click();
      });
    },
    async generateCasesState() {
      const pers_uid = this.$route.fullPath.split("/")[3];
      const final_pdf = this.popis_predmeta
        .filter(
          (p) =>
            p.predmet.case_report &&
            !p.predmet.connect_fiz_ostali
              .map((dp) => dp.uid)
              .concat(p.predmet.prav_connect_ostali.map((pp) => pp.uid))
              .includes(parseInt(pers_uid))
        )
        .map((p) => {
          return {
            case_report: p.predmet.case_report.sort(
              (a, b) => new Date(a.state_date) - new Date(b.state_date)
            ),
            archive_date: p.predmet.is_archived
              ? p.predmet.datum_arhiviranja
              : null,
          };
        });
      console.log(final_pdf);
      this.$store.state.case_state_report.all_cases_states_reports = final_pdf;

      if (this.isFizicka) {
        this.$store.state.case_state_report.stranka = `${this.represented_pers.ime} ${this.represented_pers.prezime}`;
      } else if (this.isPravna) {
        this.$store.state.case_state_report.stranka = `${this.represented_pers.ime}`;
      }
      this.$router.push("/cases-state-report");
    },
    async openReport() {
      this.$store.state.predmeti_report_data.all_predmeti =
        this.popis_predmeta.map((p) => p.predmet);
      if (this.isLaw) {
        this.$store.state.predmeti_report_data.naslov = `${this.$t(
          "person_page.report_data.view_team"
        )} ${this.represented_pers.ime} ${this.represented_pers.prezime}`;
        this.$store.state.predmeti_report_data.odvjetnik_name = `${this.represented_pers.ime} ${this.represented_pers.prezime}`;
        this.$store.state.predmeti_report_data.odvjetnik_nositelj =
          this.$route.fullPath.split("/")[3];
      } else if (this.isInstitucija) {
        this.$store.state.predmeti_report_data.naslov = `${this.$t(
          "person_page.report_data.view_instit"
        )} ${this.represented_pers.naziv}`;
      } else if (this.isFizicka || this.isLegBody) {
        this.$store.state.predmeti_report_data.naslov = `${this.$t(
          "person_page.report_data.view_person"
        )} ${this.represented_pers.ime} ${this.represented_pers.prezime}`;
      } else if (this.isPravna) {
        this.$store.state.predmeti_report_data.naslov = `${this.$t(
          "person_page.report_data.view_person"
        )} ${this.represented_pers.ime}`;
      }
      this.$router.push("/predmeti-report");
    },

    openFile(linkToFile) {
      window.open(linkToFile);
    },
    editOsoba() {
      this.$router.push(this.$router.history.current.path + "/edit");
    },
    addOpenInhouseCase: async function () {
      if (this.link_inhouse_available) {
        this.$router.push("/case/" + this.inhouse_link.predmet.group_url + "/");
      } else {
        this.inhouse_create_popup = true;
      }
    },
    async createInhouse() {
      this.main_loading = true;
      var handled_stranka = {
        name: this.represented_pers.ime + " " + this.represented_pers.prezime,
        uid: this.$route.fullPath.split("/")[3],
        isfiz: true,
      };
      if (this.isPravna) {
        handled_stranka.isfiz = false;
      }
      this.inhouse_create_popup = false;
      await predmeti_handle.initInhouseCase(handled_stranka).then((resp) => {
        this.$router.push(resp.data.case_url);
      });
    },
    switchDate(inData) {
      return moment(inData.toString()).format("L");
    },
    getCorrectName() {
      let to_return = "";
      switch (this.represented_pers.id_tip_izvora.id_tip_izvora) {
        case 1:
          to_return =
            this.represented_pers.izvor_fizicka.ime +
            " " +
            this.represented_pers.izvor_fizicka.prezime;
          break;
        case 2:
          to_return = this.represented_pers.izvor_pravna.ime;
          break;
        case 3:
          to_return = this.represented_pers.izvor_clan_tima
            .map((per) => `${per.ime} ${per.prezime}`)
            .join("<br/>");
          break;
        case 4:
          to_return = this.represented_pers.custom_ime_izvora;
          break;
        default:
          break;
      }
      return to_return;
    },

    // CRM funkcije

    async initCRM() {
      const usedMethod = this.isFizicka ? createPhysPerson : createLegalPerson;
      await usedMethod(this.$route.fullPath.split("/")[3]);
      this.main_loading = true;
      this.refreshData();
    },
    //CRM Funkcije

    // Avatar loading
    async loadAvatar() {
      if (this.represented_pers && this.isLaw) {
        var uid = this.$route.fullPath.split("/")[3];
        var loggedInUserUid = this.$store.state.logged_in_user.uid;

        // Check if viewing own profile - use graph.getPhoto() like Top.vue does
        if (uid == loggedInUserUid) {
          var url = await graph.getPhoto();
          this.avatarUrl = url;
        } else {
          // Viewing another team member's profile - use avatarService
          var url = await avatarService.getAvatarUrl(this.represented_pers);
          this.avatarUrl = url;
        }
      }
    },
  },
  destroyed() {
    document.body.classList.remove("osobe-profil");
  },
};
</script>

<style></style>
